import {Font as PeacockFont} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').IFontProps} TextProps
 * @property {import('react').ReactNode} children Text content.
 * @property {'body' | 'small' | 'xsmall' | 'xxsmall'} [size] Font size when headingLevel is not set.
 * @property {1 | 2 | 3 | 4 | 5 | 6 | 'medium4' | 'medium5' | 'medium6'} [headingLevel] Heading style level.
 * @property {import('react').CSSProperties} [style] Additional inline styles.
 * @property {'regular' | 'bold' | 'caps' | 'medium'} [variant] Font variant when headingLevel is not set.
 * @property {string} [textColorClass] Override text color utility class.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS Font.
 * Supports all Peacock DS font props.
 * @param {TextProps} props
 */
export const Text = props => {
  return <PeacockFont {...props} />
}
